import(/* webpackMode: "eager" */ "/app/apps/marketing/app/global-error.tsx");
